import { useState } from 'react';

import { Button } from '@/components/ui';

import { useModal } from '../modal/useModal';

interface ConfirmDialogProps {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  onConfirm: () => Promise<void> | void;
  onCancel?: () => void;
}

export function ConfirmDialog({
  title = 'Confirm',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  destructive = true,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  const { closeModal } = useModal();
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
    } finally {
      setLoading(false);
      closeModal();
    }
  };

  const handleCancel = () => {
    onCancel?.();
    closeModal();
  };

  return (
    <>
      <div className="ds-modal-head">
        <h2>{title}</h2>
      </div>
      <div className="ds-modal-body">
        <p style={{ margin: 0, fontSize: 13, color: 'var(--text-2)' }}>{message}</p>
      </div>
      <div className="ds-modal-foot">
        <span style={{ flex: 1 }} />
        <Button variant="ghost" onClick={handleCancel} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button
          variant={destructive ? 'danger' : 'primary'}
          onClick={handleConfirm}
          loading={loading}
        >
          {confirmLabel}
        </Button>
      </div>
    </>
  );
}
